import { DateTime } from "luxon";

export class HistoryResponse {
    dataType: string;
    entityId: number;
    userId: string;
    action: 'add' | 'update' | 'remove';
    timestamp: DateTime;
    siteId: string
    history: { [key: string]: string };
}
